import { Color, Font, breakpoints } from "@/shared/Constants";
import styled from "styled-components";

const Button = `
    align-items: center;
    background-color: ${Color.yellow2}; // COLOR POR DEFAULT
    color: ${Color.black000}; // COLOR POR DEFAULT     
    // background-image: linear-gradient(to right, #0B86CA, #160065);
    // color: ${Color.white};
    border-radius: 50px;    
    display: flex;
    ${Font.sansSemiBold};
    font-size: 12px;
    justify-content: center;
    white-space: nowrap;
    padding-top: 2px;
    width:84px;
    height:34px;
    
    ${breakpoints.mobileFirst} {
      font-size: 14px;
      width:auto;
      height:44px;
      padding:0 2rem;      
    }
    ${breakpoints.phone} {      
      padding-top:0;
    }
`;
export const SubscribeBtn = styled.a`
  position: relative;
  ${Button};
  &:hover {
    color: ${Color.black000};
    box-shadow: 0 1px 10px ${Color.yellow2}; // HOVER POR DEFAULT
    background-color: ${Color.yellow2}; // HOVER POR DEFAULT
    /* color: ${Color.white};
    background-image: linear-gradient(to right, #04486d, #09002a);
    box-shadow: 0 1px 5px #09002a; */

    transition: all 0.2s ease;
  }
  ${breakpoints.mobileFirst} {
    ${(props) =>
      props.type == "btLateral" &&
      "width: 100%; margin: 0 auto; font-size: 14px;"};
  }
  ${breakpoints.phone} {
    ${(props) =>
      props.type == "btLateral" &&
      "width: 100%; height:44px; margin: 0 auto; font-size: 14px;"};
  }

  .toolTip_text_center {
    padding: 0 1rem;
    span {
      /* margin-left: 10px !important; */
      margin-left: 0 !important;
    }
    img {
      max-height: 15px;
      width: auto !important;
    }
    .tooltipInfo-button-close {
      width: auto;
      top: 11px;
      right: 5px;
    }
    &.bottom::after {
      bottom: 28px !important;
    }
  }

  span {
    display: ${(props) => (props.type == "btLateral" ? "block" : "none")};
    margin-left: ${(props) => (props.type == "btLateral" ? "0px" : "0px")};
    font-size: 14px;
    margin-left: 0 !important;

    &.priceBefore {
      margin-left: 0px;
      strong {
        text-decoration: line-through;
      }
    }

    ${breakpoints.mobileFirst} {
      display: block;
    }
    ${breakpoints.phone} {
      margin-left: 0;
      display: none;
    }
  }
`;
